import React, { Component } from 'react'
import { localize } from '../../util/Localizer'
import Icon from '@material-ui/core/Icon'
import InputField from '../../controls/InputField'
import ErrorMessage from '../../widgets/common/ErrorMessage'

import RBButton from '../../controls/RBButton'

class Question extends Component {
  render () {
    const values = this.props.values
    return (
      <div>
        <div>
          <p>{this.props.question}</p>
        </div>
        <form id='login-form' autoComplete='off' onSubmit={this.props.checkAnswer}>
          <ErrorMessage error={this.props.error} />
          <InputField
            floatingLabelText={localize('pages.SecurityQuestion.answer')}
            fullWidth
            className='userName'
            type='text'
            id='securityAnswer'
            autoComplete='off'
            errorText={values.noSecurityAnswer ? values.noSecurityAnswer : ''}
            onChange={this.props.handleInputChange}
            onBlur={this.props.handleInputChange} /><br />
          <div className='centered'>
            <RBButton
              type='submit'
              id='btnLogin'
              label={localize('pages.SecurityQuestion.retrieve')}
              variant='contained'
              fullWidth
              primary
              loading={this.props.loading}
              disabled={this.props.disableButton} />
          </div>
          <div>
            <RBButton
              id='backButton'
              label={localize('pages.ForgotPassword.back')}
              icon={<Icon color='primary'>chevron_left</Icon>}
              onClick={this.props.handlePrev}
              styles={{ marginTop: 10 }}
              color
            />
          </div>
        </form>
      </div>
    )
  }
}

export default Question



// WEBPACK FOOTER //
// ./src/widgets/ForgotPassword/Question.js